import { useCallback, useEffect, useState } from 'react';
import { AccessibilityInfo } from 'react-native';

export const useReduceMotionStatus = (params?: Params) => {
  const { skip } = params ?? {};

  const [reduceMotionStatus, setReduceMotionStatus] = useState<ReduceMotionStatus>('undetermined');

  const toggleSetting = useCallback((reduceMotionEnabled: boolean) => {
    setReduceMotionStatus(reduceMotionEnabled ? 'enabled' : 'disabled');
  }, []);

  useEffect(() => {
    if (skip) return;

    void AccessibilityInfo.isReduceMotionEnabled()?.then(toggleSetting);

    const listener = AccessibilityInfo.addEventListener('reduceMotionChanged', toggleSetting);

    return () => {
      listener?.remove?.();
    };
  }, [skip, toggleSetting]);

  return reduceMotionStatus;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  skip?: boolean;
};

type ReduceMotionStatus = 'undetermined' | 'enabled' | 'disabled';
